'use client';

import { buttonVariants, Card, Heading, P } from '@paypoteam/ui-components';
import parse from 'html-react-parser';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import type { CtaProps } from '@/components/sections/InlineTilesSection/InlineTileSection.types';

import type { ContactCardConfigType } from './ContactCard.types';

interface ContactCardProps {
    config: ContactCardConfigType;
}

export default function ContactCard({ config }: ContactCardProps) {
    const {
        className,
        content: { text, titles },
        cta,
    } = config;

    const {
        size,
        variant,
        className: linkClassName,
        'data-test-id': linkDataTestId,
        ...linkProps
    } = cta || ({} as CtaProps);
    return (
        <Card
            size="l"
            variant="filled"
            className={className}
        >
            <div>
                {titles.map((title, i) => (
                    <Heading
                        key={`title-${i}`}
                        size={'3xl'}
                    >
                        {parse(title)}
                    </Heading>
                ))}
            </div>

            <P
                size={'s'}
                className="mt-4 min-h-12 font-inter lg:min-h-8"
            >
                {text}
            </P>

            {cta?.href && (
                <Link
                    className={cn(
                        buttonVariants({ size, variant }),
                        '!mt-6 w-fit',
                        linkClassName,
                    )}
                    data-test-id={linkDataTestId}
                    {...linkProps}
                />
            )}
        </Card>
    );
}
